import _isEmpty from 'lodash/isEmpty';
import createAndUpdateDesign from './createAndUpdateDesign';
import updateCabinetVisualizer from './updateCabinetVisualizer';
import { setQueryParam } from '../../../utils/queryParams';
import { deleteDesignById } from '../../../api/design';

const filterDesignStyleChoiceid = (designData, styleChoiceId) => {
  return Object.fromEntries(
    Object.entries(designData).filter(([key, value]) => value.DesignStyleChoiceid === styleChoiceId)
  );
};

const getDesignIdsByDesignStyleChoiceid = (designData, styleChoiceId) => {
  return Object.values(designData)
    .filter((item) => item?.DesignStyleChoiceid === styleChoiceId)
    .map((item) => item?.Id);
};

export default async function (set, get, host, designId, navigate, options = {}) {
  try {
    // Call backend API first (skip if caller already handled deletion, e.g. from the drawer)
    if (!options.skipBackendDelete) {
      const success = await deleteDesignById(host, designId);
      if (!success) {
        return;
      }
    }

    const {
      designs, designIds, selectedDesignId, styleChoiceId, styleDesignIds, projects
    } = get().cabinetVisualizer;

    // Filter out the design to delete from designs and designIds
    const updatedDesigns = { ...designs };
    delete updatedDesigns[designId];
    const updatedDesignIds = designIds.filter((id) => id !== designId);

    // Also remove from styleDesignIds to maintain proper wall tab order
    const updatedStyleDesignIds = styleDesignIds.filter((id) => id !== designId);

    // Determine the next selected design: prefer the right neighbor, otherwise the left neighbor
    let updatedSelectedDesignId = null;
    const designIdsByStyleChoiceId = getDesignIdsByDesignStyleChoiceid(designs, styleChoiceId);

    if (designIdsByStyleChoiceId.length > 0) {
      const currentIndex = designIdsByStyleChoiceId.indexOf(designId);

      if (currentIndex > 0) {
        updatedSelectedDesignId = designIdsByStyleChoiceId[currentIndex - 1];
      } else if (currentIndex === 0) {
        updatedSelectedDesignId = designIdsByStyleChoiceId[1] || null;
      } else {
        updatedSelectedDesignId = designIdsByStyleChoiceId[0] || null;
      }
    }

    // Remove the design from any project in local state
    let updatedProjects = {};
    Object.entries(projects).forEach(([projectId, project]) => {
      if (Array.isArray(project.designIds) && project.designIds.includes(designId)) {
        updatedProjects[projectId] = {
          ...project,
          designIds: project.designIds.filter((id) => id !== designId)
        };
      } else {
        updatedProjects[projectId] = project;
      }
    });

    set(
      updateCabinetVisualizer(set, get, {
        designs: updatedDesigns,
        designIds: updatedDesignIds,
        styleDesignIds: updatedStyleDesignIds, // Maintain proper order after deletion
        selectedDesignId: updatedSelectedDesignId,
        projects: updatedProjects,
      }),
      false,
      { type: 'cabinetVisualizer/deleteDesign' }
    );

    setQueryParam('designid', updatedSelectedDesignId, navigate);

    const hasNoDesignsLeft = _isEmpty(filterDesignStyleChoiceid(get().cabinetVisualizer.designs, styleChoiceId));
    if (!options.skipAutoCreate && hasNoDesignsLeft) {
      // Create a new design if there are no designs left
      createAndUpdateDesign(set, get, host, 'Wall A', {}, navigate);
    }
  } catch (err) {
    console.error(`Error deleting design with ID ${designId}:`, err);
    // Handle deletion error appropriately (e.g., display an error message to the user)
  }
}
